export const ds_TabsBlock_Entry = `
    fragment ds_TabsBlock_Entry on ds_TabsBlock_Entry {
        id
        canonicalUid
        tabs_ColorPalette
        tabs_ColorTheme
        tabs_TopSpacing
        tabs_ContainerWidth

        tabs_BgColor

        tabs_TabStyle
        tabs_TabItems {
            ... on ds_TabItem_Entry {
                title
                tabItem_Icon {
                    name
                    set
                    type
                }
                tabItem_Heading
                tabItem_BodyContent
            }
        }
    }
`